import { useState, useEffect } from "react";
import axios from "axios";
import Row from "../Row/Row";
import { Routes, Route } from "react-router";
import Grid from "../Grid/Grid";
import Spinner from "../Spinner/Spinner";
import "./Content.css"

const Content = () => {
  const [popularMedia, setPopularMedia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorLoading, setErrorLoading] = useState(false)

  useEffect(() => {
    setLoading(false);
    axios.get(`https://dream-screen-backend.onrender.com/api/media/getTrending/en-US/1`).then((res) => {
      setLoading(false);
      setErrorLoading(false);
      setPopularMedia(res.data.results);
    }).catch(err=>{
      console.log('err is', err);
      setLoading(false);
      setErrorLoading(true);
    })
    setLoading(true);
  }, []);

  return (
    <Routes>
      <Route
        path=""
        element={
          <div className="content-container">
            <div className="extraInfo">
              <h1 style={{fontSize: "3em"}}>Explore Movies and TV Shows</h1>
            </div>
            <div>
              <h1 style={{ color: "#02175a", letterSpacing: "0.05em" }}>TRENDING NOW</h1>
            </div>
            {loading && (
              <div style={{ marginTop: "60px" }}>
                <Spinner size={"3em"} color="#02175a" />
              </div>
            )}
            {!errorLoading && 
              <>
                <Row media={popularMedia} />
                <Grid media={popularMedia.slice(0, 6)} />
              </>}
            {!loading && errorLoading &&
              <div style={{maxWidth: '80%', marginTop: '20px', textAlign: 'center'}}>
                <h2 style={{ letterSpacing: "0.05em" }}>Oops! There was an error loading</h2>
                <br/>
                <h3 style={{ letterSpacing: "0.05em" }}>Don't worry we're working on it 🛠️</h3>
              </div>
            }
          </div>
        }
      />
    </Routes>
  );
};

export default Content;
